import { lazy } from 'react';
import { ANNOUNCEMENT_PERMISSIONS } from './constants';

const AnnouncementListPage = lazy(() => import('./pages/AnnouncementListPage'));

export const announcementRoutes = [
  {
    path: '/announcements',
    element: AnnouncementListPage,
    permission: ANNOUNCEMENT_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.announcements', icon: 'NotificationOutlined', group: 'system' },
  },
];
